<template>
  <div id="contract-tree-grid" class="grid-view">
    <div style="display:flex;flex-direction: row; flex: 1;">
      <ul class="custom-category-list section">
        <li :class="[contractStatusCode===-1?'active':'']" @click="categoryClick(-1)">{{ $t('CargoMsg.Cargo_All') }}({{ allCount }})</li>
        <li class="expired" :class="[contractStatusCode===ContractConstants.STAGE_EXPIRED.code?'active':'']" @click="categoryClick(ContractConstants.STAGE_EXPIRED.code)">{{ $t('CargoMsg.Cargo_Expired') }}({{ expiredCount }})</li>
        <li class="willExpired" :class="[contractStatusCode===ContractConstants.STAGE_WILLEXPIRED.code?'active':'']" @click="categoryClick(ContractConstants.STAGE_WILLEXPIRED.code)">{{ $t('CargoMsg.Cargo_NearExpiration') }}({{ willExpiredCount }})</li>
        <li class="unExpired" :class="[contractStatusCode===ContractConstants.STAGE_UNEXPIRED_AND_POSTPONED.code?'active':'']" @click="categoryClick(ContractConstants.STAGE_UNEXPIRED_AND_POSTPONED.code)">{{ $t('CargoMsg.Cargo_NotVetDueEytended') }}({{ unExpiredCount }})</li>
        <li class="history" :class="[contractStatusCode===ContractConstants.STAGE_HISTORY.code?'active':'']" @click="categoryClick(ContractConstants.STAGE_HISTORY.code)">{{ $t('CargoMsg.Cargo_History') }}({{ historyCount }})</li>
      </ul>
      <div class="main-content">
        <search-item
          config-module="101500"
          :reset="true"
          :custom-sim-query-placeholder="$t('CargoMsg.Cargo_QuickSearchContractNumber')"
          :custom-search-items="customSearchItems"
          :record-expand-status="true"
          @click-more="value=>this.isAdvancedQuery=value"
          @simSearchItemCallBack="toSimpleQuery"
          @advSearchItemCallBack="toAdvancedQuery"
        >
          <div slot="operations">
            <!--新增-->
            <el-button v-show="$checkPermission(['button_ContractManagement_addContract'])" no="add" type="primary" @click="createHandler()">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
            <!--合同配置-->
            <el-button v-show="$checkPermission(['button_ContractManagement_contractConfig'])" no="contractConfiguration" type="primary" @click="configHandler()">{{ $t('CargoMsg.Cargo_ContractConfiguration') }}</el-button>
            <!--日志记录-->
            <el-button no="logRecord" type="primary" @click="showLogHandler()">{{ $t('CargoMsg.Cargo_LogRecord') }}</el-button>
            <workflow document-config-name="SYS_CONTRACT" :job="selectedItem" state-key="state" style="display:inline;margin-left: 5px" @success="handleWorkflowSuccess" />
            <label style="fontSize: 14px; fontWeight: bold; color: #CC6666; padding-left: 10px;"> {{ $t('CargoMsg.Cargo_Reminder30Day') }} </label>
          </div>
        </search-item>
        <div class="section grid-wrapper" style="min-height:350px">
          <cargo-ag-grid
            config-module="101501"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            :wrap-text="true"
            :grid-params.sync="gridParams"
            style="width: 100%;"
            @gridReady="onGridReady"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            config-module="101501"
            :total="total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="toAdvancedQuery()"
          />
        </div>
      </div>
    </div>

    <!-- 合同配置弹窗 -->
    <contract-config-window v-if="contractConfigWindow.visible" :visible.sync="contractConfigWindow.visible" :model="contractConfigWindow.contractConfig" />

    <!-- 编辑合同弹窗 -->
    <contract-edit-window v-if="contractEditWindow.visible" :visible.sync="contractEditWindow.visible" :type="contractEditWindow.type" :model="contractEditWindow.contract" @reload="reload" />

    <!-- 日志记录弹窗 -->
    <el-dialog
      v-if="contractLogWindow.visible"
      v-el-drag-dialog
      custom-class
      :close-on-click-modal="false"
      :visible.sync="contractLogWindow.visible"
      :title="$t('CargoMsg.Cargo_LogRecord')"
      @close="contractLogWindow.visible=false"
    >
      <div class="app-main-inner-row row-grid">
        <cargo-ag-grid
          :grid-options="contractLogWindow.gridOptions"
          :column-defs="contractLogWindow.columnDefs"
          :row-data="contractLogWindow.rowData"
          :style="{width:'100%',height:'450px'}"
        />
      </div>
    </el-dialog>

    <!-- 附件 -->
    <contract-upload-file
      :visible.sync="uploadCommonFile.visible"
      :model="uploadCommonFile.model"
      :title="$t('Message.fileManagement')"
      config-module="101502"
      lob="PT"
      :document-category="uploadCommonFile.documentCategory"
      @onUploadDone="onUploadDone"
    />
  </div>
</template>

<script>
import CargoGridShowBigContent from '@/components/Cargo/grid/cargoGridShowBigContent'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { ensureExecuteSuccess } from '@/utils/commonUtil'
import {
  queryContractPageable,
  updateCountData,
  queryContractLog,
  revokeContract,
  getContractConfig,
  updateContractField
} from '@/api/partner/contract'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnTagRenderer from '@/components/Cargo/Common/ColumnTagRenderer'
import * as ContractConstants from '@/class/cargo/model/parameters/ContractConstants'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import OperationRender from '@/components/OperationRender/index'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { Contract } from '@/class/model/mdm/Contract'
import DateUtils from '@/utils/dateUtils'
import contractConfigWindow from '@/views/cargo/v0/Information/ContractManagement/components/contractConfigWindow'
import contractEditWindow from '@/views/cargo/v0/Information/ContractManagement/components/contractEditWindow'
import contractUploadFile from '@/views/cargo/v0/Information/ContractManagement/components/contractUploadFile'
import { getUserInfo } from '@/utils/auth'
import * as DocumentSource from '@/class/cargo/model/parameters/DocumentSource'
import Workflow from '@/components/Cargo/Common/Wrokflow'
import { deepClone } from '@/utils'
import { cache, cacheName } from '@/utils/cacheManager'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { getContractRules } from '@/api/partner/contractRule'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import { UNDER_REVIEW } from '@/class/cargo/model/parameters/ContractConstants'

export default {
  name: 'ContractTreeGrid',
  components: {
    Workflow,
    contractConfigWindow,
    contractEditWindow,
    contractUploadFile,
    cargoUserSelect,
    CargoAdvanceSelect,
    CargoGridShowBigContent,
    searchItem
  },
  data() {
    return {
      ColumnUtils,
      ContractConstants,
      selectTypeNames: TYPE_NAMES,
      contractRuleDownList: [],
      customSearchItems: [],
      filter: {
        pageNum: 1,
        pageSize: 50
      },
      filterJson: {},
      isAdvancedQuery: false, // 是否为高级查询
      total: 0,
      selectedItem: null,
      gridParams: {},
      isOperationRole: false,
      releatedContract: false,
      showDepartmentContract: false, // 查看同组
      showBranchContract: false, // 查看全部
      gridOptions: {
        frameworkComponents: {
          ColumnTagRenderer
        },
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onGridCellFocused(event)
        },
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.onGridRowSelected(event)
        },
        onRowClicked: (event) => {
          this.onRowClicked(event)
        },
        onRowDoubleClicked: (event) => {
          this.toLook(event.data)
        },
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        }
      },
      rowData: [],
      gridApi: null,
      conditions: [],
      contractStatusCode: -1,
      showCombinedManifest: 0,
      expiredCount: 0,
      willExpiredCount: 0,
      unExpiredCount: 0,
      historyCount: 0,
      allCount: 0,
      actualCreditGracePeriodDays: 0,
      contractConfigWindow: { // 合同配置窗口
        visible: false,
        contractConfig: null
      },
      contractEditWindow: { // 编辑窗口
        type: 'look',
        visible: false,
        contract: null
      },
      contractLogWindow: { // 合同日志
        visible: false,
        columnDefs: [
          { headerName: this.$t('CargoMsg.Cargo_OperationType'), field: 'ACTION_TYPE', colId: 'ACTION_TYPE', width: 150,
            valueFormatter: (params) => {
              return ColumnUtils.contractColumnLabelFunc(ContractConstants.CONTRACT_LOG_TYPE, parseInt(params.value))
            }
          },
          { headerName: this.$t('CargoMsg.Cargo_OperateBy'), field: 'MODIFIED_BY', colId: 'MODIFIED_BY', width: 150,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('CargoMsg.Cargo_Time'), field: 'DATE_MODIFIED', colId: 'DATE_MODIFIED', width: 150,
            valueFormatter: (params) => {
              return ColumnUtils.dateMinutesLabelFunc(params.value)
            }
          },
          { headerName: this.$t('CargoMsg.Cargo_EditField'), field: 'FIELD_NAME', colId: 'FIELD_NAME', width: 150 },
          { headerName: this.$t('CargoMsg.Cargo_OriginalValue'), field: 'ORIGINAL_VALUE', colId: 'ORIGINAL_VALUE', width: 150,
            tooltipValueGetter: (params) => params.value
          },
          { headerName: this.$t('CargoMsg.Cargo_NewValue'), field: 'NEW_VALUE', colId: 'NEW_VALUE', width: 150,
            tooltipValueGetter: (params) => params.value }
        ],
        gridOptions: {},
        rowData: []
      },
      uploadCommonFile: {
        visible: false,
        model: {},
        documentCategory: DocumentSource.CONTRACT.code.toString()
      }
    }
  },
  computed: {
    columnDefs() { // 显示列
      return [
        {
          headerName: '',
          headerCheckboxSelection: true,
          checkboxSelection: true,
          width: 55,
          pinned: 'left',
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ContractNumber'),
          field: 'contractNo',
          colId: 'contractNo',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Parter'),
          field: 'partnerName',
          colId: 'partnerName',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_CustomerLevel'),
          field: 'customerType',
          colId: 'customerType',
          valueFormatter: (params) => {
            if (!params.value) params.value = 0
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CustomerType, 'typeId', parseInt(params.value), 'chineseName')
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_AuditStatus'),
          field: 'state',
          colId: 'state',
          valueFormatter: (params) => {
            return ColumnUtils.contractColumnLabelFunc(ContractConstants.STATE, parseInt(params.value))
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_ContractStatus'),
          field: 'contractState',
          colId: 'contractState',
          valueFormatter: (params) => {
            return ColumnUtils.contractColumnLabelFunc(ContractConstants.CONTRACT_STATUS, parseInt(params.value))
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_ContractType'),
          field: 'contractType',
          colId: 'contractType',
          valueFormatter: (params) => {
            return ColumnUtils.contractColumnLabelFunc(ContractConstants.CONTRACT_TYPE, params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_EffectiveDate'),
          field: 'beginDate',
          colId: 'beginDate',
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_InvalidDate'),
          field: 'endDate',
          colId: 'endDate',
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('Partners.documentSize'),
          field: 'documentSize',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_CSR'),
          field: 'modifiedBy',
          colId: 'modifiedBy',
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_OperationDate'),
          field: 'dateModified',
          colId: 'dateModified',
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_ContractAgreement'),
          field: 'contractAgreement',
          colId: 'contractAgreement',
          valueFormatter: (params) => {
            if (params.data.associationList) {
              // 使用数组的map方法将每个元素转换为对应的标签，然后使用join方法拼接成字符串
              return params.data.associationList.map(ca => ColumnUtils.contractColumnLabelFunc(ContractConstants.CONTRACTAGREEMENT_TYPE, ca)).join('\n')
            }
            return ColumnUtils.contractColumnLabelFunc(ContractConstants.CONTRACTAGREEMENT_TYPE, params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_LogRecord'),
          field: 'creditDateType',
          colId: 'creditDateType',
          valueFormatter: (params) => {
            return ColumnUtils.contractAgreementColumnLabelFunc(params.data, params.value)
          },
          filter: false,
          filterParams: {},
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_SettlementMethod'),
          field: 'creditDateType',
          colId: 'creditDateType',
          valueFormatter: (params) => {
            return ColumnUtils.creditDateTypeColumnLabelFunc(params.data, params.value)
          },
          filter: false,
          filterParams: {},
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Limit'),
          field: 'credit',
          colId: 'credit',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_QuotaCurrency'),
          field: 'currency',
          colId: 'currency',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_DateType'),
          field: 'dateType',
          colId: 'dateType',
          valueFormatter: (params) => {
            return ColumnUtils.contractColumnLabelFunc(ContractConstants.DATETYPE_TYPE, params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_PaymentCycle'),
          field: 'termUnit',
          colId: 'termUnit',
          valueFormatter: (params) => {
            return ColumnUtils.dateLimitedColumnLabelFunc(params.data.dateLimited, params.value)
          },
          filter: false,
          filterParams: {},
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Extend'),
          field: 'postpone',
          colId: 'postpone',
          valueFormatter: (params) => {
            if (!params.value) return ''
            return ColumnUtils.checkLabelFunc(params.data, params.value.toString())
          },
          cellStyle: { textAlign: 'center' },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_ExtensionCycle'),
          field: 'postponeUnit',
          colId: 'postponeUnit',
          valueFormatter: (params) => {
            return ColumnUtils.postponeTypeColumnLabelFunc(params.data, params.value)
          },
          filter: false,
          filterParams: {},
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Remarks'),
          field: 'remarks',
          colId: 'remarks',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_WhetherBookingConfirmation'),
          field: 'stampUpload',
          colId: 'stampUpload',
          width: 150,
          valueFormatter: (params) => {
            if (!params.value) return ''
            return ColumnUtils.checkLabelFunc(params.data, params.value.toString())
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_IsContractAgreementUploaded'),
          field: 'contractUpload',
          colId: 'contractUpload',
          width: 150,
          valueFormatter: (params) => {
            if (!params.value) return ''
            return ColumnUtils.checkLabelFunc(params.data, params.value.toString())
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Operation'),
          field: '',
          colId: '',
          width: 400,
          cellStyle: { textAlign: 'center' },
          cellRendererFramework: OperationRender,
          cellRendererParams: {
            operations: [
              {
                title: this.$t('Message.fileManagement'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;',
                onClick: (params) => {
                  this.uploadHandler(params)
                },
                disabled: (params) => params.state === UNDER_REVIEW.code,
                visible: (params) => params && params.contractState !== null && (parseInt(params.contractState) !== 4) && (this.$checkPermission(['button_ContractManagement_upload']) || this.isOperationRole)
              }, {
                title: this.$t('CargoMsg.Cargo_Renew'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;',
                onClick: (params) => {
                  this.renewHandler(params)
                },
                disabled: (params) => params.state === UNDER_REVIEW.code,
                visible: (params) => params && params.contractState && (parseInt(params.contractState) === 3 || parseInt(params.contractState) === 1 || parseInt(params.contractState) === 2 || parseInt(params.contractState) === 5) && (this.$checkPermission(['button_ContractManagement_renew'] || this.isOperationRole)) && (!this.releatedContract || params.createdBy === this.$store.getters.userId || this.showDepartmentContract || this.showBranchContract)
              }, {
                title: this.$t('CargoMsg.Cargo_Edit'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;',
                onClick: (params) => {
                  this.editHandler(params)
                },
                disabled: (params) => params.state === UNDER_REVIEW.code,
                visible: (params) => params && params.contractState !== null && (parseInt(params.contractState) === 0 || parseInt(params.contractState) === 1 || parseInt(params.contractState) === 2 || parseInt(params.contractState) === 3 || parseInt(params.contractState) === 5 || parseInt(params.contractState) === 6) && (this.$checkPermission(['button_ContractManagement_edit']) || this.isOperationRole) && (!this.releatedContract || params.createdBy === this.$store.getters.userId || this.showDepartmentContract || this.showBranchContract)
              }, {
                title: this.$t('CargoMsg.Cargo_Revoke'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;color: red; font-weight: bold;',
                onClick: (params) => {
                  this.revokeHandler(params)
                },
                disabled: (params) => params.state === UNDER_REVIEW.code,
                visible: (params) => params && params.contractState !== null && (parseInt(params.contractState) === 0 || parseInt(params.contractState) === 3) && (this.$checkPermission(['button_ContractManagement_revoke']) || this.isOperationRole) && (!this.releatedContract || params.createdBy === this.$store.getters.userId || this.showDepartmentContract || this.showBranchContract)
              }, {
                title: this.$t('CargoMsg.Cargo_ContractProhibitedOperated'),
                disabled: true,
                visible: (params) => params && params.contractState && (parseInt(params.contractState) === 4)
              }, {
                title: this.$t('Message.fileManagement'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;',
                onClick: (params) => {
                  this.uploadHandler(params)
                },
                disabled: (params) => params.state === UNDER_REVIEW.code,
                visible: (params) => params && params.contractState && (parseInt(params.contractState) === 4) && (this.$checkPermission(['button_ContractManagement_upload']) || this.isOperationRole) && (!this.releatedContract || params.createdBy === this.$store.getters.userId || this.showDepartmentContract || this.showBranchContract)
              }
            ]
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_NeedToUpdateOrNot'),
          field: 'needSyshcronize',
          colId: 'needSyshcronize',
          valueFormatter: (params) => {
            return ColumnUtils.isNeedColumnLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_ContractCreator'),
          field: 'createdBy',
          colId: 'createdBy',
          width: 150,
          hide: true,
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ContractCreationTime'),
          field: 'dateCreated',
          colId: 'dateCreated',
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_PartnerCreation'),
          field: 'partnerCreatedBy',
          colId: 'partnerCreatedBy',
          width: 150,
          hide: true,
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ApplicationRules'),
          field: 'ruleName',
          colId: 'ruleName',
          width: 150,
          hide: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_ContractAuditor'),
          field: 'auditor',
          colId: 'auditor',
          width: 150,
          hide: true,
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ContractAuditTime'),
          field: 'auditTime',
          colId: 'auditTime',
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('Partners.contractAffiliatedBranch'),
          field: 'branchId',
          width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.getOfficeLabel('officeId', params.value)
          }
        }, {
          headerName: this.$t('baseInfo.partner.sales'),
          field: 'sales',
          width: 300,
          cellRenderer: (params) => {
            let value = ''
            if (params.value) {
              const arr = params.value.split(',')
              for (const index in arr) {
                if (index > 0) value += '/'
                value += ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(arr[index]), 'chineseName')
              }
            }
            return value
          },
          filterParams: {},
          filterValueGetter: (params) => {
            let value = ''
            if (params.data.sales) {
              const arr = params.data.sales.split(',')
              for (const index in arr) {
                if (index > 0) value += '/'
                value += ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(arr[index]), 'chineseName')
              }
            }
            return value
          }
        },
        {
          headerName: this.$t('SeaExport.SalesOfGoods'),
          field: 'cargoSales',
          width: 300,
          hide: true,
          suppressColumnsToolPanel: !(Number(cache.config.get('IsSpecifiedSalesBusiness')) === 1),
          cellRenderer: (params) => {
            let value = ''
            if (params.value) {
              const arr = params.value.split(',')
              for (const index in arr) {
                if (index > 0) value += '/'
                value += ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(arr[index]), 'chineseName')
              }
            }
            return value
          },
          filterParams: {},
          filterValueGetter: (params) => {
            let value = ''
            if (params.data.cargoSales) {
              const arr = params.data.cargoSales.split(',')
              for (const index in arr) {
                if (index > 0) value += '/'
                value += ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(arr[index]), 'chineseName')
              }
            }
            return value
          }
        },
        {
          headerName: this.$t('SeaExport.CustomerService'),
          field: 'csr',
          width: 300,
          hide: true,
          cellRenderer: (params) => {
            let value = ''
            if (params.value) {
              const arr = params.value.split(',')
              for (const index in arr) {
                if (index > 0) value += '/'
                value += ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(arr[index]), 'chineseName')
              }
            }
            return value
          },
          filterParams: {},
          filterValueGetter: (params) => {
            let value = ''
            if (params.data.csr) {
              const arr = params.data.csr.split(',')
              for (const index in arr) {
                if (index > 0) value += '/'
                value += ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(arr[index]), 'chineseName')
              }
            }
            return value
          }
        }
      ]
    }
  },
  async created() {
    cache.load(cacheName.CONFIG)
    this.isOperationRole = this.$checkPermission(['button_ContractManagement_operation'])
    this.releatedContract = this.$checkPermission(['role_ContractManagement_releatedContract']) && !this.$store.getters.isAdmin // 开启查看关联合作伙伴合同 仅查看
    this.showDepartmentContract = this.$checkPermission(['role_ContractManagement_departmentContract']) // 查看同组
    this.showBranchContract = this.$checkPermission(['role_ContractManagement_branchContract']) // 查看全部
    this.showCombinedManifest = Number(cache.config.get('CombinedManifest')) === 1 // 锦昶才会开这个参数
    this.actualCreditGracePeriodDays = Number(cache.config.get('actualCreditGracePeriodDays'))
    this.conditions = []
    const currentUserInfo = getUserInfo()
    const cachePageSize = JSON.parse(localStorage.getItem(`local_pagination_page_size_cache_${currentUserInfo.tenantId}_${currentUserInfo.userId}_${'101501'}`))
    if (cachePageSize) this.filter.pageSize = cachePageSize
    this.toQuery()
    // 初始化【应用规则】列表
    getContractRules().then(res => {
      this.contractRuleDownList = res.data
      this.customSearchItems = this.getCustomSearchItems()
    })
    await this.initColumnDefs()
  },
  methods: {
    // 选中 勾选框或者其他列 都会触发[获取选中行]
    async onGridCellFocused(event) {
      if (!event) return
      this.selectedItem = null
      this.$nextTick(async() => {
        // 等待gridApi被赋值
        await ensureExecuteSuccess(() => this.gridApi)
        if (this.gridApi && event.column) {
          this.gridApi.forEachNode(node => {
            if (node && node.rowIndex === event.rowIndex && node.data) {
              const nodeJob = node.data
              if (nodeJob.uuid) this.selectedItem = nodeJob
            }
          })
        }
      })
    },
    // 组装查询条件
    getCustomSearchItems() {
      const defaultSearchFields = []
      const searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'advanceSelect2'
      searchField.multiple = 1
      searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'contract.CONTRACT_RULE_UUID'
      searchField.itemLabel = 'CargoMsg.Cargo_ApplicationRules'
      searchField.tagValue = 'uuid'
      searchField.tagName = 'name'
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.defaultValue = ''
      searchField.dataProvider = this.contractRuleDownList
      defaultSearchFields.push(searchField.formatObj2Json())

      if (this.actualCreditGracePeriodDays > 0) {
        const searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'input'
        searchField.multiple = 0
        searchField.subType = 'bigdecimalrange'
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_NUMBER_RANGE'
        searchField.itemName = 'contract.PAYMENT_TERM'
        searchField.itemLabel = 'Payment.paymentPeriod'
        searchField.itemValue = []
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        defaultSearchFields.push(searchField.formatObj2Json())

        const searchFieldUnit = new AdvancedSearchField()
        searchFieldUnit.action = AdvancedSearchField.ADD_ACTION
        searchFieldUnit.itemType = 'select'
        searchFieldUnit.multiple = 0
        searchFieldUnit.itemCondition = []
        searchFieldUnit.defaultConditionVal = ''
        searchFieldUnit.fieldType = 'FIELD_DROP_DOWN_LIST'
        searchFieldUnit.itemName = 'contract.PAYMENT_TERM_UNIT'
        searchFieldUnit.itemLabel = 'Payment.paymentPeriodUnit'
        searchFieldUnit.itemValue = []
        searchFieldUnit.defaultSelected = 0
        searchFieldUnit.selected = 0
        searchFieldUnit.dropdownDataRef = 'ContractConstants.UNIT_TYPE_SEARCH'
        searchFieldUnit.lock = false
        searchFieldUnit.defaultValue = []
        searchField.dataCacheKey = 'local_cache_ContractConstants$UNIT_TYPE_SEARCH'
        defaultSearchFields.push(searchFieldUnit.formatObj2Json())
      }
      return defaultSearchFields
    },
    // 选中 勾选框触发[获取选中行]
    onGridRowSelected(event) {
      if (!event || !event.data) return
      this.selectedItem = null
      if (event.node.isSelected()) {
        const node = event.data
        if (node.uuid) this.selectedItem = node
      }
      this.$nextTick(async() => {
        // 等待gridApi被赋值
        await ensureExecuteSuccess(() => this.gridApi)
      })
    },
    onGridReady(p) {
      this.gridApi = p.api
    },
    // 行点击触发事件
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedItem = null
      const node = event.data
      if (node.uuid) this.selectedItem = node
    },
    // 新增编辑重新查询
    reload() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        if (this.filter.contractNo) {
          this.toSimpleQuery(this.filter.contractNo)
        } else { // 客户打开模块，直接编辑合同，此时也需要刷新
          this.toSimpleQuery()
        }
      }
    },
    // 左边客户状态点击切换
    categoryClick(contractStatusCode) {
      this.contractStatusCode = contractStatusCode
      this.toAdvancedQuery()
    },
    // 更新左边栏位的条数
    updateCountData() {
      const conMap = {}
      conMap.officeId = this.$store.getters.currentOfficeId
      const departments = getCacheListByKey(basicCacheKeys.basic_data_Department)
      const keys = departments ? Array.from(departments, p => p.uuid) : []
      const requestBody = { conMap, keys, branchId: this.$store.getters.currentOfficeId }
      if (this.showCombinedManifest && this.contractStatusCode >= 1 && this.contractStatusCode <= 3) {
        const conditions = []
        const stateCondition = {
          'fieldName': 'contract.state',
          'fieldType': 'FIELD_MULTI_DROP_DOWN_LIST',
          'operator': 'IN',
          'value': [1]
        }
        conditions.push(stateCondition)
        requestBody.conditions = conditions
      }
      updateCountData(requestBody).then(res => {
        this.expiredCount = res.data.expiredCount || 0
        this.willExpiredCount = res.data.willExpiredCount || 0
        this.unExpiredCount = res.data.unExpiredCount || 0
        this.historyCount = res.data.historyCount || 0
        this.allCount = res.data.allCount || 0
      })
    },
    // 查询
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 简单查询
    toSimpleQuery(keyword) {
      if (typeof keyword !== 'undefined') {
        this.filter.contractNo = keyword.trim() // 合同编号
        this.filter.pageNum = 1
      }

      const roleMap = {}
      roleMap.contractNo = this.filter.contractNo
      this.conditions = []
      this.queryCommon(roleMap)
    },
    // 高级查询
    toAdvancedQuery(data) {
      if (data) this.conditions = data
      // 高级查询条件组装
      const roleMap = {}
      this.queryCommon(roleMap)
    },
    // 查询公用
    queryCommon(roleMap) {
      const departments = getCacheListByKey(basicCacheKeys.basic_data_Department)
      const keys = departments ? Array.from(departments, p => p.uuid) : []
      roleMap.contractStatusCode = this.contractStatusCode.toString()
      const requestBody = {
        conditions: this.conditions,
        roleMap,
        keys: keys,
        pageNum: this.filter.pageNum,
        pageSize: this.filter.pageSize,
        branchId: this.$store.getters.currentOfficeId
      }

      if (this.showCombinedManifest && this.contractStatusCode >= 1 && this.contractStatusCode <= 3) {
        let foundState = false
        for (let i = 0; i < requestBody.conditions.length; i++) {
          if (requestBody.conditions[i].fieldName.toUpperCase() === 'contract.state'.toUpperCase()) {
            requestBody.conditions[i].operator = 'IN'
            requestBody.conditions[i].value = [1]
            foundState = true
          }
        }
        if (!foundState) {
          const stateCondition = {
            'fieldName': 'contract.state',
            'fieldType': 'FIELD_MULTI_DROP_DOWN_LIST',
            'operator': 'IN',
            'value': [1]
          }
          requestBody.conditions.push(stateCondition)
        }
      }
      this.loading = getLoading()
      queryContractPageable(requestBody).then(res => this.handleQueryData(res)).finally(() => {
        this.loading.close()
      })
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      const batchList = []
      const list = []
      // 重复批次下合同不用都显示
      for (const data of res.data.list) {
        if (data.contractBatchNo && batchList.includes(data.contractBatchNo)) {
          continue
        }
        if (data.contractBatchNo) {
          data.documentSize = data.associationDocumentSize
          batchList.push(data.contractBatchNo)
        }
        list.push(data)
      }
      this.rowData = list
      this.total = Number(res.data.total)
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      if (this.gridApi) this.gridApi.clearFocusedCell()

      // 若查出来的数据左右不相等，则刷新左边栏位客户数
      if ((this.contractStatusCode === parseInt(ContractConstants.STAGE_EXPIRED.code) && this.expiredCount !== this.total) ||
        (this.contractStatusCode === parseInt(ContractConstants.STAGE_WILLEXPIRED.code) && this.willExpiredCount !== this.total) ||
        (this.contractStatusCode === parseInt(ContractConstants.STAGE_UNEXPIRED_AND_POSTPONED.code) && this.unExpiredCount !== this.total) ||
        (this.contractStatusCode === parseInt(ContractConstants.STAGE_HISTORY.code) && this.historyCount !== this.total) ||
        (this.contractStatusCode === -1 && this.total !== (this.expiredCount + this.willExpiredCount + this.unExpiredCount + this.historyCount))) {
        this.updateCountData()
      }
    },
    // 获取选中行
    readSelectedRows(tips = true) {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0 && tips) {
        throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
      }
      return rows
    },
    // 刷新表格
    refreshAgGrid(runToQuery = false) {
      // 刷寻右边查询结果
      if (runToQuery) this.toQuery()
      this.gridApi.refreshCells({ force: true })
      this.gridApi.clearFocusedCell()
    },
    // 合同配置
    configHandler() {
      // 获取合同配置
      getContractConfig({ branchId: this.$store.getters.currentOfficeId }).then(res => {
        const contractConfig = res.data
        if (contractConfig) {
          this.contractConfigWindow.contractConfig = contractConfig
          this.contractConfigWindow.visible = true
        }
      })
    },
    // 日志记录
    showLogHandler() {
      if (!this.selectedItem || !this.selectedItem.uuid) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectContractRecord'))
        return
      }
      this.loading = getLoading()
      queryContractLog({ key: this.selectedItem.uuid }).then(res => {
        this.contractLogWindow.rowData = res.data
        this.contractLogWindow.visible = true
      }).finally(() => {
        this.loading.close()
      })
    },
    // 上传
    uploadHandler(params) {
      if (!params || !params.uuid) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectContractRecord'))
        return
      }
      this.uploadCommonFile.model = params
      this.uploadCommonFile.visible = true
    },
    // 获取合同新对象
    getContract(params) {
      const contract = deepClone(params)
      contract.contractUuid = params.uuid
      contract.partnerId = params.partnerId
      contract.customerType = params.customerType
      contract.modifiedBy = 0
      return contract
    },
    // 新增
    createHandler() {
      const contract = new Contract().fillDefaultValue().getData()
      // 生效日期: 系统日期
      contract.beginDate = DateUtils.formatStandardDate(new Date())
      // CARGO-8310，合同【新增】信息维护
      contract.contractAgreement = 1
      contract.dateType = 'ETD'
      contract.creditDateType = -1
      const localCurrency = RateUtil.localCurrencyByOffice()
      contract.currency = localCurrency
      contract.termUnit = 0
      contract.paymentTermUnit = 0
      contract.postpone = 0
      // contract.postponeType = 1;
      contract.postponeUnit = 0
      contract.isNeedSyshcronize = 1
      contract.branchId = this.$store.getters.currentOfficeId
      this.contractEditWindow.type = 'add'
      this.contractEditWindow.contract = contract
      this.contractEditWindow.visible = true
    },
    // 续签
    renewHandler(params) {
      if (!params || !params.uuid) {
        this.$message.warning(this.$t('Information.ContractRecordIsEmpty'))
        return
      }
      const contract = this.getContract(params)
      // 生效日期: 失效日期 + 1
      if (contract.endDate) {
        const curDate = new Date(contract.endDate)
        contract.beginDate = new Date(curDate)
        contract.beginDate.setDate(curDate.getDate() + 1)
      }
      contract.endDate = ''
      contract.contractNo = ''
      this.contractEditWindow.type = 'renew'
      this.contractEditWindow.contract = contract
      this.contractEditWindow.visible = true
    },
    // 双击查看
    toLook(params) {
      if (!params || !params.uuid) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectContractRecord'))
        return
      }
      const contract = this.getContract(params)
      this.contractEditWindow.contract = contract
      this.contractEditWindow.type = 'look'
      this.contractEditWindow.visible = true
    },
    // 编辑
    editHandler(params) {
      if (!params || !params.uuid) {
        this.$message.warning(this.$t('Information.ContractRecordIsEmpty'))
        return
      }
      const contract = this.getContract(params)
      this.contractEditWindow.contract = contract
      this.contractEditWindow.type = 'edit'
      this.contractEditWindow.visible = true
    },
    // 撤销
    revokeHandler(params) {
      if (!params || !params.uuid) {
        this.$message.warning(this.$t('Information.ContractRecordIsEmpty'))
        return
      }
      const msg = this.$t('Information.DoOfThe00', [params.partnerName, params.contractN]) +
        '<span style="color: red; font-weight: bold;">' +
        this.$t('Information.operationTip') +
        '</span>'
      this.$confirm(msg, this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        dangerouslyUseHTMLString: true, // 关键配置：允许解析HTML
        type: 'info'
      }).then(() => {
        const contract = this.getContract(params)
        contract.contractType = ContractConstants.FIRST_SIGN.code
        contract.contractState = ContractConstants.STAGE_TERMINATE.code
        // Contract.revokeContract(contract,revokeContractHandler,faultHandler);
        this.loading = getLoading()
        revokeContract(contract).then(res => {
          this.$message.success(this.$t('Information.ContractRevocationSuccessful'))
          this.toQuery()
        }).finally(() => {
          this.loading.close()
        })
      })
    },
    async handleWorkflowSuccess(value) {
      let contractUuid = value
      if (!contractUuid && this.selectedItem && this.selectedItem.uuid) {
        contractUuid = this.selectedItem.uuid
      }
      if (contractUuid) {
        const item = {}
        item.contractUuid = contractUuid
        item.operate = 'SPHT'
        this.loading = getLoading()
        await updateContractField({ conMap: item }).then(res => {
        }).finally(() => {
          this.loading.close()
        })
      }
      this.refreshAgGrid(true)
    },
    onUploadDone() {
      this.toQuery()
    },
    async initColumnDefs() {
      if (this.actualCreditGracePeriodDays > 0) {
        this.columnDefs.push({
          headerName: this.$t('Payment.paymentPeriod'),
          field: 'paymentTermUnit',
          colId: 'paymentTermUnit',
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.dateLimitedColumnLabelFunc(params.data.paymentTerm, params.value)
          },
          filter: false,
          filterParams: {},
          width: 150
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#contract-tree-grid {
  .custom-category-list{
    margin-top: 0;
    margin-right: 5px;
    list-style: none;
    min-width: 150px;
    li {
      position: relative;
      padding:10px 25px;
      border:1px solid #d9d9d9;
      border-bottom: none;
      cursor: pointer;
      &:nth-last-child(1){
        border:1px solid #d9d9d9;
      }
      &.active {
        background-color: #009fd6;
        color:#fff;
        &::before{
          content:'';
          position: absolute;
          width: 5px;
          top:0;
          left:0;
          bottom:0;
          background-color: rgba(0,0,0,.3);
        }
        border-color: #009fd6;
        &.expired{
          background-color: #00A6F4;
          border-color: #00A6F4;
        }
        &.willExpired{
          background-color: #00A795;
          border-color: #00A795;
        }
        &.unExpired{
          background-color: #5469BA;
          border-color: #5469BA;
        }
        &.history{
          background-color: #8DCE64;
          border-color: #8DCE64;
        }
      }
    }
  }
}
</style>
